document.addEventListener("DOMContentLoaded", (event) => {
    const sectionInit = (section)=> {
        if (!section.hasAttribute('data-speed')) section.setAttribute('data-speed', '1.5');
        if (!section.hasAttribute('data-pausable')) section.setAttribute('data-pausable', 'true');

        setTimeout(()=> {
            Marquee3k.init({
                selector: 'marquee',
            });
        },500)

        windowResizeEvents?.forEach(event=> {
            window.addEventListener(event, () => {
                Marquee3k.refreshAll();
            })
        })
    }
    initSectionOnVisible({
        selector: '.marquee',
        threshold: 0,
        init: (section) => {
            sectionInit(section)
        }
    });
})
